import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Select } from '../../../../../../../../CommonComponents/OPL/Select/Select/Select';
import { useAccountFormContext } from '../../context/useAccountFormContext';
import { useYearAgeOptionsWithRightLabel } from '../ContributionStartYearSelect/useYearAgeOptionsWithRightLabel';

export const ContributionEndYearSelect = () => {
  const formBag = useFormContext();

  const {
    options: { ContributionEndYearOptions },
  } = useAccountFormContext();

  const options = useYearAgeOptionsWithRightLabel({ options: ContributionEndYearOptions });

  return (
    <Controller
      control={formBag.control}
      name="bankAccount.ContributionEndYear"
      render={({ field: { value, onChange } }) => {
        return (
          <Select
            isPortal
            value={value}
            options={options}
            onChange={contribution => onChange(contribution)}
            label="Contribution End Year"
            tooltip="With plan default, contributions automatically end when the account's earmarked goal starts. However, if an account is not earmarked to any goal, contributions will continue until the end of plan."
          />
        );
      }}
    />
  );
};
